import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { FilePathMode } from 'app/registries/consts/metadata-consts';

import { IAttribute } from 'app/model/base/annotation';
import { SftpServerLinkedService } from 'shell-models-lib';

@Metamodel.model({
    name: 'SftpReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(SftpServerLinkedService)
    }
})

export class SftpStoreReadSettings extends BlobTypeStoreReadSettings {
    public static readonly DISABLE_CHUNKING: IAttribute;

    // sftp store read settings doesn't have enablePartitionDiscovery
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        display: stringResources.ModelName_DisableChunking,
        association: 'DISABLE_CHUNKING',
        templatable: true
    })
    public disableChunking?: boolean = false;
}
